<template>
  <div class="admin-container">
    <div class="admin-header">
      <h1>Admin Dashboard</h1>
      <!-- <ThemeToggle /> -->
      <div>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Users">
              <b-card-text> ... ... Users ...</b-card-text>
            </b-tab>
            <b-tab title="Settings">
              <b-card-text> ... ... Settings ...</b-card-text>
            </b-tab>

            <b-tab title="PopUp">
              <b-card-text> <blankModal /></b-card-text>
            </b-tab>
            <b-tab title="Form">
              <b-card-text>
                <div style="display: flex; justify-content: center">
                  <div style="width: 125%">
                    <BlankForm />
                  </div>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab title="Patient Demographics" active>
              <b-card-text>
                <div>
                  <b-tabs content-class="mt-3" justified>
                    <!-- <b-tab title="MOCK">
                      <b-row>
                        <b-col>
                          <PatientHomeAddressForm />
                        </b-col>

                        <b-col>
                        </b-col>
                      </b-row>
                    </b-tab> -->
                    <b-tab title="General" active><PatientGeneralForm /> </b-tab>
                    <b-tab title="Home Address"><PatientHomeAddressForm /> </b-tab>
                    <b-tab title="Work Address"><PatientWorkAddressForm /> </b-tab>
                    <b-tab title="Guarantor"><PatientGurantorForm /> </b-tab>
                    <b-tab title="Emergency Information"> <PatientEmergencyInfoForm /></b-tab>
                    <b-tab title="Other Information"> <PatientOtherInfoForm /></b-tab>
                    <b-tab title="Notes"> <PatientNotesForm /></b-tab>
                    <b-tab title="Insurance Policies"><PatientInsuranceForm /> </b-tab>
                    <b-tab title="Contact"><PatientContactForm /> </b-tab>
                  </b-tabs>
                </div>
              </b-card-text>
            </b-tab>

            <b-tab title="Vitals">
              <b-card-text> ... ... Patient Vitals Form ... </b-card-text>

              <PatientVitalsForm />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import PatientVitalsForm from "./modules/Patient/PatientForms/PatientVitalsForm.vue";

import BlankForm from "./modules/Patient/BlankForm.vue";
import blankModal from "./modules/Patient/blankModal.vue";
import consolePatientForm from "./modules/Patient/PatientForms/consolePatientForm.vue";
import PatientGeneralForm from "./modules/Patient/PatientForms/PatientGeneralForm.vue";
import PatientHomeAddressForm from "./modules/Patient/PatientForms/PatientHomeAddressForm.vue";
import PatientWorkAddressForm from "./modules/Patient/PatientForms/PatientWorkAddressForm.vue";
import PatientGurantorForm from "./modules/Patient/PatientForms/PatientGurantorForm.vue";
import PatientEmergencyInfoForm from "./modules/Patient/PatientForms/PatientEmergencyInfoForm.vue";
import PatientOtherInfoForm from "./modules/Patient/PatientForms/PatientOtherInfoForm.vue";
import PatientNotesForm from "./modules/Patient/PatientForms/PatientNotesForm.vue";
import PatientInsuranceForm from "./modules/Patient/PatientForms/PatientInsuranceForm.vue";
import PatientContactForm from "./modules/Patient/PatientForms/PatientContactForm.vue";
import ThemeToggle from "./components/ThemeToggle.vue";

const AreIdsShown = ref(true);

const patientProps = ref({
  personID: 14526,
  firstName: "JENNIFER",
  middleName: "M",
  lastName: "AARSTAD",
  dateOfBirth: "09/16/1971",
  patientID: 2405061,
  memberID: "N/A",
  insuranceCarrier: "UNKNOWN",
  dob: "19710916",
  gender: "F",
  providerName: "Grizzle, Melissa",
  serviceDate: "12/14/2022",
  lastSeenByMe: "Grizzle, Melissa",
  chartReviewDate: "0001-01-01T00:00:00Z",
  chartReviewBy: null,
  chartReviewNeeded: true,
  chartReviewComment: null,
  chartReviewRole: null,
  emrId: null,
  startDate: "1900-01-01T00:00:00Z",
  nextAppointmentWith: "",
  nextAppointmentReason: "",
  nextAppointmentType: "",
  nextAppointmentComment: "",
  patientStatus: true,
  endDate: "1900-01-01T00:00:00Z",
  appointmentLocation: null,
  isScheduled: false,
  nextAppointment: "1900-01-01T00:00:00Z",
});

onMounted(() => {
  console.log("onMounted() :      ADMIN >>>>");
});
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background-color: #322525;
}

.admin-header {
  background-color: #2a505c7d;
  color: #00d9ff;
  padding: 1rem;
  text-align: center;
}

.admin-content {
  display: flex;
  min-height: calc(100vh - 80px);
}

.admin-nav {
  width: 250px;
  background-color: #34495e;
  padding: 1rem;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 0.5rem;
}

.nav-link {
  text-decoration: none;
  display: block;
  padding: 0.75rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.nav-link:hover {
  background-color: #2c3e50;
}

.admin-main {
  flex: 1;
  padding: 2rem;
}

.content-section {
  background-color: rgb(28, 95, 102);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
